module.exports = __webpack_public_path__ + "img/loading.5e7b0b6c.svg";